module.exports = __webpack_public_path__ + "media/images/welcome-thankyou-3f77561a60f4e11e29cbb1dcd69f0038.svg";